const checkIfFiltered = arrayOfFilters => arrayOfFilters.every(filter => !filter);

export default checkIfFiltered;
